import moment from 'moment';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import CustomTooltip from '../../../CustomTooltip';

export default function Profile({ document, isTemplateFile }) {
    const user_info = useSelector((state) => state?.generalReducers?.user_info);

    const userInitials = useMemo(
        () =>
            user_info?.first_name || user_info?.last_name
                ? user_info.first_name.charAt(0) + user_info.last_name.charAt(0)
                : user_info?.email?.charAt(0) ?? '' + user_info?.email?.charAt(1),
        [user_info]
    );

    const editorInfo = useMemo(() => {
        const name = isTemplateFile
            ? user_info?.first_name || user_info?.last_name
                ? user_info?.first_name + ' ' + user_info?.last_name
                : user_info?.email
            : document?.requester_name;

        const date = isTemplateFile
            ? moment().format('MMM DD, YYYY')
            : moment(document?.date_updated).format('MMM DD, YYYY');

        const time = isTemplateFile ? moment().format('hh:mm A') : moment(document?.date_updated).format('hh:mm A');

        return {
            name,
            date,
            time,
        };
    }, [document, isTemplateFile, user_info]);

    return (
        <CustomTooltip
            title={`${isTemplateFile ? 'Created' : 'Last edited'} by ${editorInfo?.name}:: ${editorInfo?.date} :: ${
                editorInfo?.time
            }`}
            placement="bottom-end"
            width="176px"
        >
            <div className="flex !h-8 !w-8 items-center justify-center rounded-full !border !border-[#749BCB] bg-[#EAF0F766]">
                <span className="text-sm text-[#395BA9] font-bold capitalize">{userInitials}</span>
            </div>
        </CustomTooltip>
    );
}
